exports.inject = function(module) {
  module.factory('Plan', ['$http', '$q', exports.factory]);
};

exports.factory = function($http, $q) {
  var planInfo;

  function info() {
    return planInfo;
  }

  function getPlanInfo(id) {
    return $http.get('/accounts/api/v1/tariff/' + id + '/?format=json')
    .then(function(response) {
      return (planInfo = {
        id: id,
        description: response.data.description,
        name: response.data.name,
        price: response.data.price,
        max_lines: response.data.max_lines,
        prepaid_minutes: response.data.prepaid_minutes,
        overage_price: response.data.overage_price,
        trial_period_days: response.data.trial_period_days,
      });
    });
  }

  function getPlanInfoByPosition(position) {
    return $http.get('/accounts/api/v1/tariff/?format=json&display_order=' + position)
    .then(function(response) {
      return response.data.objects;
    });
  }

  function getPlans() {
    return $http.get('/accounts/api/v1/tariff/?format=json&limit=100')
    .then(function(response) {
      return response.data.objects;
    });
  }

  return {
    getPlans: getPlans,
    getPlanInfo: getPlanInfo,
    info: info,
    getPlanInfoByPosition: getPlanInfoByPosition
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/plan-service.js
 ** module id = 236
 ** module chunks = 0
 **/